import React from 'react'
import { Save } from 'lucide-react'
import { buttonVariants, buttonDisabledStyle } from "../../styles/buttonStyles";
import { useTranslation } from "react-i18next";

interface SaveButtonProps {
  onSave: () => void
  iconSize?: number
  disabled?: boolean
  children?: React.ReactNode
}

const SaveButton: React.FC<SaveButtonProps> = ({
  onSave,
  iconSize: _iconSize = 24,
  disabled = false,
  children
}) => {
  const { t } = useTranslation('modals');
  return (
    <button
      type="button"
      onClick={onSave}
      disabled={disabled}
      className={`${buttonVariants.save} ${disabled ? buttonDisabledStyle : ''}`}
    >
      <Save className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2 flex-shrink-0" />
      <span className="truncate">{children || t('fileNameModal.buttons.save')}</span>
    </button>
  )
}

export default SaveButton
